import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SiteSelectionState {
  selectedSiteId: string | null;
  selectSite: (id: string) => void;
  clearSelection: () => void;
}

export const useSiteSelection = create<SiteSelectionState>()(
  persist(
    (set) => ({
      selectedSiteId: null,
      selectSite: (id) => set({ selectedSiteId: id }),
      clearSelection: () => set({ selectedSiteId: null }),
    }),
    {
      name: "site-selection",
    },
  ),
);
